import { Check, ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { IMAGES, waLink } from "@/data/site";
import { Reveal, SectionKicker } from "./Reveal";

export const Services = () => {
  const { t } = useLang();
  const s = t.services;

  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="py-24 sm:py-32 bg-[#050505]"
    >
      <div className="container-x">
        <Reveal className="max-w-2xl">
          <SectionKicker>{s.kicker}</SectionKicker>
          <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            {s.title}
          </h2>
          <p className="mt-4 text-base text-zinc-400 leading-relaxed">
            {s.subtitle}
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {s.items.map((item, i) => (
            <Reveal
              key={item.key}
              delay={i * 0.07}
              className={i === 0 ? "lg:col-span-2 lg:row-span-1" : ""}
            >
              <article
                data-testid={`service-card-${item.key}`}
                className="group relative h-full overflow-hidden rounded-2xl border border-white/10 bg-[#0d0d0d] transition-all duration-300 hover:border-brand/50 hover:-translate-y-1"
              >
                <div
                  className={`relative overflow-hidden ${
                    i === 0 ? "h-64 lg:h-72" : "h-52"
                  }`}
                >
                  <img
                    src={IMAGES.services[item.key]}
                    alt={item.title}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d] via-[#0d0d0d]/30 to-transparent" />
                </div>
                <div className="p-6">
                  <h3 className="font-heading text-xl font-semibold text-white flex items-start justify-between gap-2">
                    {item.title}
                    <ArrowUpRight className="h-5 w-5 text-brand opacity-0 -translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-all shrink-0" />
                  </h3>
                  <ul className="mt-4 space-y-2">
                    {item.points.map((p) => (
                      <li key={p} className="flex items-start gap-2.5 text-sm text-zinc-400">
                        <Check className="h-4 w-4 text-brand mt-0.5 shrink-0" />
                        {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </article>
            </Reveal>
          ))}

          <Reveal delay={0.1}>
            <div className="h-full min-h-[220px] rounded-2xl border border-brand/30 bg-gradient-to-br from-brand/15 to-transparent p-6 flex flex-col justify-between">
              <div>
                <h3 className="font-heading text-2xl font-bold text-white">
                  {t.nav.quote}
                </h3>
                <p className="mt-2 text-sm text-zinc-300">{s.subtitle}</p>
              </div>
              <a
                href="#cotizador"
                data-testid="services-cta-btn"
                className="mt-6 inline-flex items-center justify-center gap-2 h-12 rounded-full bg-brand hover:bg-brand-hover text-white font-semibold transition-colors"
              >
                {s.cta}
                <ArrowUpRight className="h-4 w-4" />
              </a>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
